import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { PedidosEnviados } from "../../Components/pedidos/listas";
import styled from "styled-components";

export function Enviados() {
  const navigate = useNavigate();
  const session = useSelector((store) => store.auth);

  useEffect(() => {
    if (!session) navigate("/");
  }, [session]);

  return (
    <Container>
      <PedidosEnviados />
    </Container>
  );
}

export const Container = styled.div`
  padding: 0 0 0 var(--navbar-size);
  min-height: 100vh;
`;
